define('views/pages/WidgetPageView',['underscore','jquery','PageView',  'InputPhoneView', 'app', 'hooks',
    'WidgetCollectionView','TagCommander'],
    function(_,$,PageView, InputPhoneView,app,hooks,
         WidgetCollectionView,TagCommander
    ){

    return PageView.extend({
        pageName:'Widget',
        events:{
        },

        initialize:function(options){

	        var view = this,
                widgetContainer = view.$('.widget-container');
            var use_js = widgetContainer.data('usejs'),
                groupName = widgetContainer.data('widget-group'),
                widgetGroup;
            view.groupName = groupName;
            // PageView constructor heritage
            PageView.prototype.initialize.apply(this,arguments);
            //
            if(!options.el || (use_js == 1)){
                var link_rewrite;
                if(link_rewrite = options.link_rewrite){
                    view.groupName = groupName = app.getWidgetGroups().findWhere({link_rewrite:link_rewrite}).get('indentifiant');
                }
                widgetGroup = app.getWidgetGroup(groupName);
                if(widgetGroup && !widgetGroup.useJs()){
                    view.loadAjaxDom(widgetGroup);
                }else{
                    view.render();
                }

            }else{
                hooks.execHook('widgetPageViewWithoutJsRender',{view:view,options:options});
            }
        },
        render:function(){
	        var view = this,
                collection = new WidgetCollectionView(view.groupName, {type:'page'})

            view.attachView(collection);
            view.$el.html('');
            view.$el.append(collection.el);

        },
        loadAjaxDom:function(widgetGroup){
            var view = this;
            view.$el.html('<div class="widget-page-loader"><div class="loader abs"></div></div>')
            $.get({
                url:widgetGroup.getUrl(),
                data:{
                    ajax:1
                }
            }).done(function (dom){
                view.$el.html(dom);
            }).fail(function(){
                app.error();
            })
        },
        microtemplate:function(options){
            this.pageOptions = _.defaults(options,{});;
            this.rerender();
        },
        rerender:function(){
            this.render();
        },
        initialMetaTitle:function(){
            var group = app.getWidgetGroup(this.groupName),
                groupTitle = group ? group.get('titre_seo') : false;
            if(groupTitle){
                document.title = groupTitle;
            }else{
                PageView.prototype.initialMetaTitle.apply(this);
            }
        },
        startPageTagCommander:function(options) {
            var view = this;
            TagCommander.LoadPage(view.pageName,{groupName:view.groupName});
        },

    })

});
